<div class="tab-container mat-typography">
  <h3>{{ 'labels.heading.Identities' | translate }}</h3>

  <div class="layout-row align-flex-end">
    <button
      mat-raised-button
      color="primary"
      (click)="addIdentifier()"
      *LOSxHasPermission="'CREATE_CLIENTIDENTIFIER'"
    >
      <fa-icon icon="plus" class="m-r-10"></fa-icon>
      {{ 'labels.buttons.Add' | translate }}
    </button>
  </div>

  <table mat-table #identifiersTable [dataSource]="clientIdentities" [ngStyle]="{ 'margin-top': '3%' }">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Id' | translate }}</th>
      <td mat-cell *matCellDef="let identity">{{ identity.id }}</td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Type' | translate }}</th>
      <td mat-cell *matCellDef="let identity">{{ identity.documentType.name }}</td>
    </ng-container>

    <ng-container matColumnDef="documentKey">
      <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Document Key' | translate }}</th>
      <td mat-cell *matCellDef="let identity">{{ identity.documentKey }}</td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Description' | translate }}</th>
      <td mat-cell *matCellDef="let identity">{{ identity.description }}</td>
    </ng-container>

    <ng-container matColumnDef="documents">
      <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Identity Documents' | translate }}</th>
      <td mat-cell *matCellDef="let identity">
        @if (identity.documents?.length) {
          <div class="document-grid">
            @for (document of identity.documents; track trackByDocumentId($index, document)) {
              <div class="document-card">
                <div
                  class="thumb"
                  [class.clickable]="isPreviewable(document)"
                  role="button"
                  tabindex="0"
                  [attr.aria-label]="('labels.buttons.Preview' | translate) + ': ' + document.name"
                  (keydown.enter)="isPreviewable(document) && openDocumentPreview(identity, document)"
                  (keydown.space)="isPreviewable(document) && openDocumentPreview(identity, document)"
                  (click)="isPreviewable(document) && openDocumentPreview(identity, document)"
                >
                  @if (previewThumbnails[document.id]) {
                    <img
                      [src]="previewThumbnails[document.id]"
                      [alt]="document.name"
                      [title]="document.name"
                      loading="lazy"
                    />
                  } @else {
                    <div class="placeholder">
                      <fa-icon icon="file"></fa-icon>
                      <span>{{ document.fileName || document.name }}</span>
                    </div>
                  }
                  @if (isPreviewable(document)) {
                    <div class="preview-overlay">
                      <fa-icon icon="eye"></fa-icon>
                    </div>
                  }
                </div>
                <div class="card-body">
                  <div class="title">{{ document.name }}</div>
                  @if (document.fileName) {
                    <div class="meta">{{ document.fileName }}</div>
                  }
                </div>
              </div>
            }
          </div>
        } @else {
          <span class="muted">{{ 'labels.text.NoDocuments' | translate }}</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Status' | translate }}</th>
      <td mat-cell *matCellDef="let identity">
        {{ identity.status === 'clientIdentifierStatusType.active' ? 'active' : 'inactive' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Actions' | translate }}</th>
      <td mat-cell *matCellDef="let identity; let i = index">
        <button
          class="identity-action-button"
          mat-raised-button
          color="warn"
          [title]="'labels.buttons.Delete' | translate"
          [attr.aria-label]="'labels.buttons.Delete' | translate"
          (click)="deleteIdentifier(identity.clientId, identity.id, i)"
          *LOSxHasPermission="'DELETE_CLIENTIDENTIFIER'"
        >
          <fa-icon icon="times"></fa-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="identitiesColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: identitiesColumns"></tr>
  </table>
</div>

<div #identityLightbox class="document-lightbox-host"></div>
